import { render, staticRenderFns } from "./orderitem-card.vue?vue&type=template&id=281db879&"
import script from "./orderitem-card.vue?vue&type=script&lang=js&"
export * from "./orderitem-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports